
import XDialog from 'vux/src/components/x-dialog/index.vue'

import md5 from '../../../tools/md5Tool'
import UserApi from '../../../api/user'
import validator from '../../../tools/validator'
import store from '../../../store'
import Icon from '../../../icons'
export default{
components: {
XDialog,
Icon
},
props: {
showType: {
type: String,
default: '0' // '0' or '1', '0' only show type 0, '1' show type '0' and '1'
}
},
data() {
return {
show: false,
viewShowType: '0', // '0' or '1'
verifyCode: '',
verifyText: '获取',
verifyButtonEnable: true,
isChecking: false,
validateBtnEnable: false,
needRealTimeCheck: false,
showNotice: false,
noticeText: '验证码格式不正确',
timer: Object
}
},
methods: {
cancelBtnClick() {
this.show = false;
},
sureBtnClick() {
if (this.showType === '0') {
this.show = false;
this.$emit('onClickSureBtn');
} else {
this.viewShowType = '1';
this.sendBtnClick();
}
},
sendBtnClick() {
let that = this;
this.verifyButtonEnable = false;
let phone = store.getters.phone;
let verCodeSignature = md5.md5('1labGVZwvBD6fsapfa1DTGdAUb1w123' + phone.slice(0, 7));
UserApi.sendVerifyCode({
mblNo: phone,
verCodeType: '2',
verCodeSignature: verCodeSignature
}).then(() => {
let times = 0;
this.timer = window.setInterval(() => {
that.verifyText = (60 - times) + 's';
if (times >= 60) {
window.clearInterval(that.timer);
that.verifyButtonEnable = true;
that.verifyText = '获取';
}
times++;
}, 1000);
}).catch(() => {
this.verifyButtonEnable = true;
});
},
validateVerifyCode() {
this.needRealTimeCheck = true;
this.showNotice = !validator.checkVerifyCode(this.verifyCode);
if (!this.showNotice) {
let phone = store.getters.phone;
this.isChecking = true;
this.validateBtnEnable = false;
UserApi.checkVerifyCode({
mblNo: phone,
verCodeType: '2',
verCode: this.verifyCode
}).then(() => {
this.isChecking = false;
this.show = false;
store.dispatch('saveHasAuthorize');
this.realTimeCheckButtonEnable();
}).catch((error) => {
this.isChecking = false;
this.realTimeCheckButtonEnable();
this.$toast.show(error.errMsg);
});
}
},
hookVerifyCodeChanged() {
this.realTimeCheckButtonEnable();
if (this.needRealTimeCheck) {
if (validator.checkEmpty(this.verifyCode)) {
this.showNotice = false;
} else {
this.showNotice = !validator.checkVerifyCode(this.verifyCode);
if (this.showNotice) {
this.noticeText = '验证码格式不正确';
}
}
}
},
realTimeCheckButtonEnable() {
this.validateBtnEnable = !validator.checkEmpty(this.verifyCode);
},
closeSelf() {
this.show = false;
}
},
mounted() {
this.$watch('verifyCode', function (newVal, oldVal) {
if (!this.isChecking) {
this.hookVerifyCodeChanged();
}
});
this.$watch('show', function (newVal, oldVal) {
if (newVal === true) {
this.viewShowType = '0';
this.verifyCode = '';
this.showNotice = false;
this.verifyText = '获取';
} else {
if (this.timer) {
window.clearInterval(this.timer);
}
}
});
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-grant-view.vue